module.exports = __webpack_public_path__ + "static/media/background-lg.f9dd32a1.jpg";